import Newsletter from './components/NewsletterComponent';
export default Newsletter